module.exports = require("video.js");